import GrossSalesService from "@/api/services/grossSales";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async importFile(_, { organizationId, file }) {
      return await GrossSalesService.importFile(organizationId, file);
    },
  },
};
